/**
 * bshub
 *
 */

; ((w, $) => {
    'use strict'

    const MobileToggleMenu = () => {
        let headerWrap = $('.header-mobile')
        headerWrap.on('click', '.header-mobile-action', function (e) {
            e.preventDefault();
            headerWrap.toggleClass('__open-mobile-menu');
            headerWrap.find('.menu-container').slideToggle();
        })
        //$('.__menu-mobi-open .main-header').on('click', 'a.nav-link', function (e) {
        //    $('.navigation-icon').trigger('click')
        //})

        //$(document).on('click', function (e) {
        //    //console.log(e.target)
        //    if ($(e.target).hasClass('navigation-cover')) {
        //        $('body').removeClass('__menu-mobi-open')
        //    }
        //})
        $('.main-menu-mobile, .mega-menu, .main-menu').on('click', '.menu-item.menu-item-has-children', function (e) {
            //e.preventDefault();
            e.stopPropagation()
            if ($(e.target).is('a, a *')) return;
            $('.menu-item.menu-item-has-children').removeClass('__open-submenu');
            $('.menu-item.menu-item-has-children').find('>.sub-menu').slideUp();
            $(this).toggleClass('__open-submenu');
            $(this).find('>.sub-menu').slideToggle();
        })
    }

    const BSearchModal = () => {
        const searchModalWrap = $('.search-modal-wrap');
        const openSearch = $('.btn-search-action');
        const closeSearch = $('.btn-close-search');
        const searchInput = searchModalWrap.find('input.search-field');
        const rsWrap = searchModalWrap.find('.result-wrap')
        let typingTimer; //timer identifier
        let doneTypingInterval = 1000; //time in ms (5 seconds)

        openSearch.on('click', function (e) {
            e.preventDefault();
            $('body').addClass('__open-search');
        });
        closeSearch.on('click', function (e) {
            e.preventDefault();
            $('body').removeClass('__open-search');
        })

        async function doneTyping() {
            const keyword = searchInput.val()

            const rs = await fetch(`${php_data.rest_url}wp/v2/search?search=${keyword}`);
            const data = await rs.json()
            let html = data.length ? await data.map((e, i) => {
                return `<div class="item"><a href="${e.url}"><span>${e.subtype}</span><h4>${e.title}</h4></a></div>`
            }) : 'No posts found!'

            await rsWrap.removeClass('__is-loading')
            await searchModalWrap.remove('__is-searching')
            rsWrap.html(html)
        }

        searchInput.on('input', function (e) {
            const keyword = $(this).val();
            rsWrap.empty()
            searchModalWrap.removeClass('__is-searching')
            clearTimeout(typingTimer);
            if (keyword) {
                rsWrap.addClass('__is-loading')
                searchModalWrap.addClass('__is-searching')
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            }
        })
    }

    const BMegaMenu = () => {
        const openMegaMenu = $('.btn-mega-menu-action');
        const closeMegaMenu = $('.btn-close-megamenu');
        openMegaMenu.on('click', function (e) {
            e.preventDefault();
            $('body').addClass('__open-megamenu');
        })
        closeMegaMenu.on('click', function (e) {
            e.preventDefault();
            $('body').removeClass('__open-megamenu');
        })
    }

    const BShareGlobal = () => {
        let shareWrap = $('.global-share-wrap');
        let share = $('.global-share-wrap >span');
        share.on('click', function (e) {
            if ($(w).width() > 768) return;
            e.stopPropagation();
            shareWrap.find('ul').slideToggle()
        })
    }

    const isTouchDevice = () => {
        return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
    }

    const clickMenuTouchDevices = () => {
        if (isTouchDevice() === true) {
            $('.menu-item.menu-item-has-children').addClass('menu-touch-devices');
        }
    }

    const changeColorSelectForm = () => {
        $('select.ninja-forms-field').on('change', function () {
            $(this).addClass('has-changed')
        });
    }

    const BSAChangeStylingDropdownForm = () => {
        let customSelect = $(".list-select-wrap .nf-field-element");
        customSelect.each(function () {
            let thisCustomSelect = $(this),
                options = thisCustomSelect.find("option"),
                firstOptionText = options.first().text();

            let selectedItem = $("<div></div>", {
                class: "selected-item"
            })
                .appendTo(thisCustomSelect)
                .text('What are you interested in hearing about from us?*');

            let allItems = $("<div></div>", {
                class: "all-items all-items-hide"
            }).appendTo(thisCustomSelect);

            options.each(function () {
                let that = $(this),
                    optionText = that.text(),
                    valueOption = that.val();

                let item = $("<div></div>", {
                    class: "item",
                    on: {
                        click: function () {
                            let selectedOptionText = that.text(),
                                selectedOptionVal = that.val();
                            selectedItem.text(selectedOptionText).removeClass("arrowanim").addClass("active-color");
                            allItems.addClass("all-items-hide");
                            customSelect.find('select').val(selectedOptionVal).change();
                            //console.log(customSelect.find('select').val())
                        }
                    }
                })
                    .appendTo(allItems)
                    .data('value', valueOption)
                    .attr("data-value", valueOption)
                    .text(optionText);
            });

        });

        let selectedItem = customSelect.find(".selected-item"),
            allItems = customSelect.find(".all-items");

        selectedItem.on("click", function (e) {
            let currentSelectedItem = $(this),
                currentAllItems = currentSelectedItem.next(".all-items");

            allItems.not(currentAllItems).addClass("all-items-hide");
            selectedItem.not(currentSelectedItem).removeClass("arrowanim");

            currentAllItems.toggleClass("all-items-hide");
            currentSelectedItem.toggleClass("arrowanim");

            e.stopPropagation();
        });

        $(document).on("click", function () {
            let opened = customSelect.find(".all-items:not(.all-items-hide)"),
                index = opened.parent().index();

            customSelect
                .eq(index)
                .find(".all-items")
                .addClass("all-items-hide");
            customSelect
                .eq(index)
                .find(".selected-item")
                .removeClass("arrowanim");


        });
    }

    const BsHubSlider = () => {
        if (!$(".bshub-block--main-slide .slide-inner").length) return;
        $(".bshub-block--main-slide .slide-inner").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            infinite: true,
            dots: true,
            autoplay: false,
            cssEase: 'linear',
            speed: 500,
            autoplaySpeed: 3000,
            arrows: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        });
    }

    const Ready = () => {
        MobileToggleMenu();
        BSearchModal();
        BMegaMenu();
        clickMenuTouchDevices();
    }

    $(document).on('nfFormReady', function () {
        BSAChangeStylingDropdownForm();
    });

    $(document).ready(function () {
        BsHubSlider();
    });


    // Browser load completed
    $(w).on('load', function () {
        BShareGlobal();
        changeColorSelectForm();
    });

    $(w).on('load resize', function () {
        if ($(w).width() > 768) {
            $('.global-share-wrap').find('ul').removeAttr('style')
        }
        if ($(w).width() > 576) {
            $('.mega-menu').find('.sub-menu').removeAttr('style')
        }
    });
    $(Ready)

})(window, jQuery)
